document.addEventListener('DOMContentLoaded', function () {

  const tabSections = document.querySelectorAll('.cm-faq[data-faq-group]');

  tabSections.forEach(section => {

    const group = section.dataset.faqGroup;
    const tabs = section.querySelectorAll('.cm-faq-tab');
    const activeLabel = section.querySelector('[data-faq-active-label]');

    const wrappers = document.querySelectorAll(
      `[data-faq-managed="true"][data-faq-group="${group}"]`
    );

    const validKeys = Array.from(tabs).map(tab => tab.dataset.faqTarget);

    function activateTab(key) {

      tabs.forEach(tab => {
        const isActive = tab.dataset.faqTarget === key;

        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive);

        if (isActive && activeLabel) {
          activeLabel.textContent = tab.textContent;
        }
      });

      wrappers.forEach(wrapper => {
        wrapper.style.display =
          wrapper.dataset.faqKey === key ? 'block' : 'none';
      });

      try { sessionStorage.setItem(`cmFaq-${group}`, key); } catch (e) {}
    }

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        activateTab(tab.dataset.faqTarget);
      });
    });

    let savedKey = null;
    try { savedKey = sessionStorage.getItem(`cmFaq-${group}`); } catch (e) {}
    const defaultKey = validKeys.includes(savedKey) ? savedKey : validKeys[0];

    if (defaultKey) activateTab(defaultKey);

  });

});
